export default __webpack_public_path__ + "static/code-editor-sequence-e8c9a4284e407e844c5a914077dfad2e.gif";